import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";
  import { EoiStatus } from "@/enums/EoiStatus";
  import store from "@/store";
  

  
export default /*@__PURE__*/_defineComponent({
  __name: 'RemoveWaitlistModal',
  props: {
    subscriptionId: {
      type: String,
      required: true,
    },
    isOpen: {
      type: Boolean,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }

  function confirm() {
    store
      .dispatch("subscription/removeFromWaitlist", props.subscriptionId)
      .then(() => {
        emits("confirm");
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

const __returned__ = { emits, props, close, confirm, LotAssignmentModal, get EoiStatus() { return EoiStatus }, get store() { return store } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})